"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var createRecord_1 = require("./createRecord");
var preventEvents_1 = require("../utils/preventEvents");
var immutable_1 = require("immutable");
var getFacetValue = function (_this, type) {
    if (type === 'range') {
        return _this.filter(function (_, k) { return k === 'from' || k === 'to'; });
    }
    ;
    if (type === 'category') {
        return immutable_1.List([_this.get('value')]);
    }
    ;
    return _this.get('value');
};
var Filter = (function (_super) {
    __extends(Filter, _super);
    function Filter(filter, updater) {
        var _this = _super.call(this, filter.update('values', function (values) {
            return values.map(function (v) { return new FilterValue(v.withMutations(function (i) { return i
                .set('type', filter.get('type'))
                .set('name', filter.get('name')); }), updater, filter); });
        })) || this;
        _this.resetValues = function (e) {
            preventEvents_1.preventEvents(e);
            var filterName = _this.get('name');
            _this.updater('filters', function (f) { return f.remove(filterName); });
            return _this;
        };
        _this.updater = updater;
        return _this;
    }
    ;
    return Filter;
}(createRecord_1.default('Filter')));
exports.Filter = Filter;
var FilterValue = (function (_super) {
    __extends(FilterValue, _super);
    function FilterValue(value, updater, filter) {
        var _this = _super.call(this, value) || this;
        _this.toggle = function (e) {
            preventEvents_1.preventEvents(e);
            var filterName = _this.index;
            var value = getFacetValue(_this, _this.get('type'));
            _this.updater('filters', function (f) {
                return f.withMutations(function (filters) {
                    var filter = filters.get(filterName);
                    var index = filter.indexOf(value);
                    return !~index ? filters.remove(filterName) : filters.removeIn([filterName, index]);
                });
            });
            return _this;
        };
        _this.updater = updater;
        _this.index = filter.get('name');
        return _this;
    }
    return FilterValue;
}(createRecord_1.default('FilterValue')));
exports.FilterValue = FilterValue;
//# sourceMappingURL=filters.js.map